import { type ProjectTemplateAttributes } from './generated/ProjectTemplateAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ProjectTemplate extends ProjectTemplateAttributes {}

@model
class ProjectTemplate extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProjectTemplate' = 'ProjectTemplate';
  get typename(): 'ProjectTemplate' {
    return 'ProjectTemplate';
  }

  static internalTypename: 'ProjectTemplate' = 'ProjectTemplate';
  get internalTypename(): 'ProjectTemplate' {
    return 'ProjectTemplate';
  }

  static inputType = 'ProjectTemplateAttributes!';

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    projectTemplateConfiguration: attr.belongsTo({
      readable: true,
      typename: 'ProjectConfiguration',
    }),
    projectTemplateWorkingConfiguration: attr.belongsTo({
      writeShape: ['cardLayout'],
      readable: true,
      typename: 'ProjectConfiguration',
    }),
  };
  // End auto-generated
}

export default ProjectTemplate;
